import React, {memo} from "react";
import {Checkbox, Stack, Tooltip, Typography} from "@mui/material";

const PreventativeColumnHeader = memo(({
                                           label,
                                           skippable,
                                           columnSkipChecked = false,
                                           columnSkipIndeterminate = false,
                                           columnSkipDisabled = false,
                                           onColumnSkipChange,
                                           columnSkipTooltip,
                                           skipFieldHint,
                                       }) => (
    <Stack direction="row" spacing={0.5} alignItems="center" sx={{minWidth: 0}}>
        {skippable && (
            <Tooltip title={columnSkipTooltip ?? skipFieldHint ?? ''}>
                <span>
                    <Checkbox
                        size="small"
                        checked={columnSkipChecked}
                        indeterminate={columnSkipIndeterminate}
                        disabled={columnSkipDisabled}
                        onClick={(event) => event.stopPropagation()}
                        onChange={(event) => {
                            event.stopPropagation();
                            onColumnSkipChange?.(event.target.checked);
                        }}
                        sx={{p: 0.25, flexShrink: 0}}
                        inputProps={{'aria-label': columnSkipTooltip ?? skipFieldHint ?? label}}
                    />
                </span>
            </Tooltip>
        )}
        <Typography variant="body2" fontWeight="bold" noWrap sx={{minWidth: 0}}>
            {label}
        </Typography>
    </Stack>
));

export default PreventativeColumnHeader;
